<nav class="navbar navbar-expand-lg p-3">
	<div class="container-fluid">
		<a class="navbar-brand me-5" aria-label="Brand Logo" role="button" (click)="redirectToFleetTrackingPage()">
			<img src="assets/logos/logo-gt-watermark.svg" alt="Brand Logo" height="40" />
		</a>
		<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
			aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse" id="navbarNav">
			<ul class="navbar-nav gap-3 me-auto mb-2 mb-lg-0">
				<li class="nav-item cursor-pointer" role="button" routerLinkActive="active"
					[routerLinkActiveOptions]="{ exact: true }">
					<a class="nav-link fw-bolder" aria-current="page" (click)="redirectToFleetTrackingPage()">Home</a>
				</li>
				<!-- <li class="nav-item" routerLinkActive="active">
					<a class="nav-link fw-bolder" aria-current="page" routerLink="/driver-management">Driver IQ</a>
				</li> -->
				<li class="nav-item cursor-pointer" role="button" routerLinkActive="active">
					<a class="nav-link fw-bolder" routerLink="/control-tower">Control Tower</a>
				</li>
				@if (canAccessFuelManagement || canAccessDrivers || canAccessAssetIQ) {
					<li class="nav-item dropdown" routerLinkActive="active">
						<a class="nav-link fw-bolder dropdown-toggle" href="javascript:void(0)" role="button"
							data-bs-toggle="dropdown" aria-expanded="false">
							Operations
						</a>
						<ul class="dropdown-menu">
							@if (canAccessFuelManagement) {
								<li><a class="dropdown-item fw-bolder" routerLink="/fuel-management">Fuel Management</a></li>
							}
							@if (canAccessDrivers) {
								<li><a class="dropdown-item fw-bolder" routerLink="/driver-management">Drivers</a></li>
							}
							@if (canAccessAssetIQ) {
								<li><a class="dropdown-item fw-bolder" routerLink="/asset-management">Asset IQ</a></li>
							}
						</ul>
					</li>
				}
				<!-- <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link fw-bolder">Dashboard</a>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link fw-bolder dropdown-toggle" href="javascript:void(0)" role="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        Business
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Cost management</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">AI Route cost</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Globaltrends</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Overtime Management</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Saving opportunity</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Nucleus</a></li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link fw-bolder dropdown-toggle" href="javascript:void(0)" role="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        Operations
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Fleet Tracking</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Fuel Management</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Bottlenecks</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Maintenance</a></li>
                        <li><a class="dropdown-item fw-bolder" routerLink="/driver-management">Drivers</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">ETA</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Setup</a></li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle fw-bolder" href="javascript:void(0)" role="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        Reports
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Action</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Another action</a></li>
                        <li><a class="dropdown-item fw-bolder" href="javascript:void(0)">Something else here</a></li>
                    </ul>
                </li> -->
			</ul>
			<div class="d-flex align-items-center gap-3">
				<button id="support" class="btn btn-outline-light rounded-pill d-flex justify-content-center align-items-center"
					aria-label="Help" (click)="redirectToSupportPage()">
					<i class="ph-duotone ph-question text-secondary"></i>
				</button>
				<!-- <button class="btn btn-outline-light rounded-pill d-flex justify-content-center align-items-center" aria-label="Notifications">
                    <i class="ph-duotone ph-bell text-secondary"></i>
                </button> -->
				<button class="btn btn-outline-light rounded-pill d-flex justify-content-center align-items-center"
					[class.settings-active]="isSettingsActive"
					aria-label="Settings" (click)="redirectToSettingsPage()">
					<i class="ph-duotone ph-gear" [class.text-secondary]="!isSettingsActive"></i>
				</button>

				<div class="avatar dropdown">
					<a class="nav-link dropdown-toggle" href="" role="button" data-bs-toggle="dropdown" aria-expanded="false">
						<app-avatar [name]="fullName" [size]="40"></app-avatar>
					</a>
					<ul class="dropdown-menu dropdown-menu-end dropdown-menu-logout">
						<li class="d-flex justify-content-center">
							<app-avatar [name]="fullName" [size]="64"></app-avatar>
						</li>
						<li>
							<p class="text-dark fw-bold mt-3 mb-0">{{fullName}}</p>
							<p class="text-secondary email">{{user.email}}</p>
						</li>
						<!-- <li>
							<button class="btn btn-md btn-outline-light text-dark fw-bold fs-5" href="javascript:void(0)">
								Manage account
							</button>
						</li> -->
						<li>
							<button (click)="logout()" class="btn btn-outline-light text-dark fw-bold fs-5">
								Logout
							</button>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</nav>